/*
 *
 * AttendanceControl reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_ATTENDANCECONTROL,
  LOAD_ATTENDANCECONTROL,
  LOAD_ATTENDANCECONTROL_SUCCESS,
  LOAD_ATTENDANCECONTROL_ERROR,
  CHANGE_ATTENDANCECONTROL,
  CHANGE_ATTENDANCECONTROL_SUCCESS,
  CHANGE_ATTENDANCECONTROL_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  loadingCnahge: false,
  error: false,
  errorChange: false,
  deleteSuccessful: false,
  attendanceData: false,
  id: false,
};

/* eslint-disable default-case, no-param-reassign */
const attendanceControlReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_ATTENDANCECONTROL:
        return initialState;

      // LOAD
      case LOAD_ATTENDANCECONTROL:
        draft.loading = true;
        draft.error = false;
        draft.id = action.id;
        break;

      case LOAD_ATTENDANCECONTROL_SUCCESS:
        draft.attendanceData = action.attendanceData;
        draft.loading = false;
        break;

      case LOAD_ATTENDANCECONTROL_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_ATTENDANCECONTROL:
        draft.attendanceData = {
          ...state.attendanceData,
          ...action.attendanceData,
        };
        draft.loadingCnahge = true;
        draft.errorChange = false;
        break;

      case CHANGE_ATTENDANCECONTROL_SUCCESS:
        draft.attendanceData = action.attendanceData;
        draft.loadingCnahge = false;

        break;

      case CHANGE_ATTENDANCECONTROL_ERROR:
        draft.errorChange = action.errorChange;
        draft.loadingCnahge = false;
        break;
    }
  });

export default attendanceControlReducer;
